import { useBreakpoint } from "hooks/use-breakpoint";
import { isMobile } from "react-device-detect";
import { PhoneMobileView, PhoneView, Container } from "./styles";

export function Art() {
  const isTablet = useBreakpoint("md");

  return (
    <Container>
      {isMobile && !isTablet ? <PhoneMobileView /> : <PhoneView />}
    </Container>
  );
}
